var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAverageTime48Line = function SvgIconAverageTime48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.23 18.17 2.35-2.35-2.4-2.4-2.42 2.42a13.165 13.165 0 0 0-6.05-2.42V11.7h2.3V8.3h-8v3.4h2.3v1.72c-2.24.29-4.31 1.15-6.05 2.42l-2.42-2.42-2.4 2.4 2.35 2.35a13.149 13.149 0 0 0-2.97 8.33c0 7.28 5.92 13.2 13.2 13.2 7.28 0 13.2-5.92 13.2-13.2 0-3.16-1.12-6.05-2.97-8.33h-.02ZM24 36.3c-5.4 0-9.8-4.4-9.8-9.8s4.4-9.8 9.8-9.8 9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 26h-3.4v5h3.4v-5ZM25.7 21h-3.4v10h3.4V21ZM31.2 24h-3.4v7h3.4v-7Z",
    fill: "current"
  })));
};
export default SvgIconAverageTime48Line;